
import DnFormField from '@digitalnatives/form-field';

export default {
    extends: DnFormField
};
